import React from 'react';
import moment from 'moment';

import styles from './academicPerformanceStyles';

import Table from 'buyside/components/presentation/Table/table';
import Link from 'buyside/components/presentation/Link/link';

const AcademicPerformance = ({ userProfile }) => {
  const { profileTestResults } = userProfile;
  return (
    <div className={styles.testResultsTable}>
      <Table
        headings={['Type', 'Score', 'Date', 'Score Report']}
        items={profileTestResults}
        getItemAttrs={testResult => [
          testResult.name.toUpperCase(),
          testResult.score &&
            `${testResult.score} ${testResult.maxScore ? `out of ${testResult.maxScore}` : ''}`,
          moment(testResult.date).format('MM/YYYY'),
          testResult.url && (
            <Link to={testResult.url}>{testResult.name === 'GPA' ? 'Transcript' : 'Report'}</Link>
          )
        ]}
        rowClassName={styles.testResultsTableRow}
      />
    </div>
  );
};

export default AcademicPerformance;
